module.exports = __webpack_public_path__ + "static/media/img_panel_stairs.504b2631.jpg";